import { initReactI18next } from 'react-i18next'

import { AVAILABLE_LANGUAGES, DEFAULT_LANGUAGE, DEVELOPMENT_MODE } from './settings'
import commonDE from './translations/de/common.json'
import commonEN from './translations/en/common.json'
import commonFR from './translations/fr/common.json'
import commonNL from './translations/nl/common.json'

import type { Locale } from 'antd/es/locale'
import deDE from 'antd/locale/de_DE'
import enGB from 'antd/locale/en_GB'
import frFR from 'antd/locale/fr_FR'
import nlBE from 'antd/locale/nl_BE'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            en: {
                common: commonEN,
            },
            nl: {
                common: commonNL,
            },
            fr: {
                common: commonFR,
            },
            de: {
                common: commonDE,
            },
        },
        defaultNS: 'common',
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: AVAILABLE_LANGUAGES,
        debug: DEVELOPMENT_MODE,
        returnEmptyString: false,
    })

// Ant Design locale mapping
// https://ant.design/docs/react/i18n
const antdLocales: Record<string, Locale> = {
    en: enGB,
    fr: frFR,
    de: deDE,
    nl: nlBE,
}

export function getAntdLocale(lang?: string) {
    const lng = lang || i18n.language
    return antdLocales[lng] || enGB
}

export default i18n
